import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "login-form" }

import studentDialog from "./studentDialog.vue"
import { ref, reactive, onMounted, computed } from 'vue';
import { useStore } from "vuex"
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'userInfoDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter();
const props = __props
const dialogShow = ref(props.popupShow)
const userInfo = ref(store.state.userInfo)
const studentShow = ref(false)
const emitList = __emit
const cityInfo = computed(() => {
    const { provinceName, cityName, areaName } = userInfo.value
    let str = ''
    if (provinceName) {
        str += provinceName
    }
    if (cityName) {
        str += cityName
    }
    if (areaName) {
        str += areaName
    }
    return str
})

const isBCustom = computed(() => {
    return userInfo.value.schoolNmae ? true : false
})

function closeEvent() {
    emitList('close')
}

function studentClose() {
    router.go(0)
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogShow).value = $event)),
    width: "640px",
    title: "个人信息",
    center: "",
    onClose: closeEvent,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (userInfo.value.isFromB=='00')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                color: "#ef8b25",
                plain: "",
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (studentShow.value=true))
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("信息维护")
                ])),
                _: 1,
                __: [2]
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_descriptions, {
            class: "margin-top",
            column: 2,
            border: "",
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(userInfo.value.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "学籍号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(userInfo.value.studentNo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "地区" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(cityInfo.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "手机号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(userInfo.value.userPhone), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "账号ID" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(userInfo.value.userId), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      (studentShow.value)
        ? (_openBlock(), _createBlock(studentDialog, {
            key: 0,
            popupShow: studentShow.value,
            isPerson: "",
            onClose: studentClose
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})